$(document).ready(function () {

	if ($(window).width() <= 991) {

		$('.mega-box').hide();

		$(".nav-links li span").click(function () {

			$(".nav-links li a").removeClass("active-menu")
			$(".mega-box").slideUp("normal");

			if ($(this).next(".mega-box").is(':hidden') == true) {

				$(this).addClass("active-menu");
				$(this).next(".mega-box").slideDown("normal")	
			
			}			
		});

	}

});



//Search Popup
$(document).ready(function () {
	$("#search-icon").click(function () {
		$(".search-popup").addClass("show");
	});
	$("#close-search").click(function () {
		$(".search-popup").removeClass("show");
	});
});



//Header scroll class
$(window).scroll(function () {
	if ($(this).scrollTop() > 220) {
		$('#header').addClass('header-scrolled');
	} else {
		$('#header').removeClass('header-scrolled');
	}
});

// $(document).ready(function () {
// // Init slick slider + animation
// $('.slider').slick({
// 	autoplay: true,
// 	speed: 1500,
// 	fade: true,
// 	lazyLoad: 'progressive',
// 	arrows: true,
// 	dots: false,
// 	prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
// 	nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',

// 	responsive: [
// 		{
// 		  breakpoint: 480,
// 		  settings: {
// 			arrows: false,       
// 		  }
// 		}
		
// 	  ]
// }).slickAnimation();
  
//   $('.slider').hover(function(){
//     $('.slider').slick('slickPrev');
//   })

//   $('.slider').mouseover(function(){
//     setTimeout(function(){  $('.slider').slick('slickNext');}, 4000);
   
//   })

  
// // Init slick slider + animation
// $('.collection__slider').slick({
// 	autoplay: false,
// 	speed: 2000,
// 	fade: true,
// 	lazyLoad: 'progressive',
// 	arrows: true,
// 	dots: false,
// 	prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
// 	nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',

// 	responsive: [
// 		{
// 		  breakpoint: 480,
// 		  settings: {
// 			arrows: false,       
// 		  }
// 		}
		
// 	  ]
// }).slickAnimation();
  

//   $('.collection__slider').hover(function(){
//     $('.collection__slider').slick('slickPrev');
//   })

//   $('.collection__slider').mouseover(function(){
//      setTimeout(function(){  $('.collection__slider').slick('slickNext');}, 2000);
//     //$('.collection__slider').slick('slickNext');
//   })
  
  
  
// $('.slick-nav').on('click touch', function (e) {
// 	e.preventDefault();
// 	var arrow = $(this);
// 	if (!arrow.hasClass('animate')) {
// 		arrow.addClass('animate');
// 		setTimeout(() => {
// 			arrow.removeClass('animate');
// 		}, 1600);
// 	}
// });


//  // slick slider + thumb Img nav

// $('.Product__slider').slick({
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	arrows: false,
// 	fade: true,
// 	asNavFor: '.Product__slider__nav'
// });
// $('.Product__slider__nav').slick({
// 	slidesToShow: 3,
// 	slidesToScroll: 1,
// 	asNavFor: '.Product__slider',
// 	arrows: true,
// 	dots: false,
// 	centerMode: true,
//    focusOnSelect: true,
//    infinite: true,
// });

// });

// Cart Popup
$(document).ready(function () {
	$('a.cart__button').click(function(){
		$('div.cart__popup').toggleClass('popup--box');
	});
});
$(document).on('click','#PageContainer',function(e){
    //$("div.cart__popup").slideUp();
  if(event.target.tagName.toLowerCase() !== 'button')
{
   $('div.cart__popup').removeClass('popup--box');
}
    
});


// Quantity Holder - / +

$(function () {
	$(".numbers-row .newadd").on("click", function () {
		var $button = $(this);
		var oldValue = $button.parent().find("input").val();
		if ($button.attr('data-type') == "plus") {
          if(oldValue < 999){
			var newVal = parseFloat(oldValue) + 1;
          }else {
          var newVal = parseFloat(oldValue);
          }
		} else {
			// Don't allow decrementing below zero
			if (oldValue > 1) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 1;
			}
		}
		$button.parent().find("input").val(newVal);
	});
});




// -------------------accordion START-----------------------



$(document).ready(function () {
  
		
	//ACCORDION BUTTON ACTION (ON CLICK DO THE FOLLOWING)
	$('.accordionButton').click(function () {

		//REMOVE THE ON CLASS FROM ALL BUTTONS
		$('.accordionButton').removeClass('on');

		//NO MATTER WHAT WE CLOSE ALL OPEN SLIDES
		$('.accordionContent').slideUp('normal');

		//IF THE NEXT SLIDE WASN'T OPEN THEN OPEN IT
		if ($(this).next().is(':hidden') == true) {

			//ADD THE ON CLASS TO THE BUTTON
			$(this).addClass('on');

			//OPEN THE SLIDE
			$(this).next().slideDown('normal');
		}

	});


	/*** REMOVE IF MOUSEOVER IS NOT REQUIRED ***/

	//ADDS THE .OVER CLASS FROM THE STYLESHEET ON MOUSEOVER 
	$('.accordionButton').mouseover(function () {
		$(this).addClass('over');

		//ON MOUSEOUT REMOVE THE OVER CLASS
	}).mouseout(function () {
		$(this).removeClass('over');
	});

	/*** END REMOVE IF MOUSEOVER IS NOT REQUIRED ***/


	/*************************
	CLOSES ALL S ON PAGE LOAD
	**************************/
	$('.accordionContent').hide();
  $('.firsto').addClass('on');
  $('.accordionContent.first').show();

	// $('.accordionContent.first').show();

});

// -------------------accordion END------------------




// Window less then 767px 

$(document).ready(function () {


	if ($(window).width() <= 767) {

		$('.cloudFilter__list').hide();

		$(".cloudFilter__title").click(function () {

			$(".cloudFilter__title").removeClass("active")
			$(".cloudFilter__list").slideUp("normal");

			if ($(this).next(".cloudFilter__list").is(':hidden') == true) {

				$(this).addClass("active");
				$(this).next(".cloudFilter__list").slideDown("normal")	
			
			}			
		});

	}

});





      $(document).on('click','.add',function(e){
    //alert("hi");
    var form = $(this).parents('form:first');
    e.preventDefault()
    $.ajax({
        type: 'POST',                             
        url: '/cart/add.js',
        dataType: 'json',                               
        data: form.serialize(),
        success: function(data) {
         // console.log(data);
          $('.cartCount ').css("display", "block");
            
         // window.location.href = '/cart';
          
          			$.getJSON('/cart.js', function (data ) {
                      
              if(data.item_count > 0){
                   $('.cart-counter').html('('+ data.item_count +')');
                  $('.cart-subtotal__price').html(''+ parseFloat(data.items_subtotal_price/ 100).toFixed(2)+'');
                                  $('.total-Items-price').html('$'+ parseFloat(data.items_subtotal_price/ 100).toFixed(2)+'');
                                    var price="";var dataw="";var cartn="";
                                    $.each(data.items, function(i, datas){
                                     var price= data.items[i].final_line_price/100;
                                          var vrnt="";
                                             $.each(data.items[i].options_with_values, function(y, datas){
                                             if(data.items[i].options_with_values[y].name=="Color"){
                                             vrnt+='<div class="cart-item__color">'+ data.items[i].options_with_values[y].name +': '+ data.items[i].options_with_values[y].value+'</div>';
                                             }else if (data.items[i].options_with_values[y].name=="Size"){
                                              vrnt+='<div class="cart-item__size">'+ data.items[i].options_with_values[y].name +': ' + data.items[i].options_with_values[y].value+'</div>'; 
                                             }
                                           });
                                    
                                     function imgURL(src, size) {
 								// remove any current image size then add the new image size
                                    return src
                                      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
                                      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
                                        return '_'+size+match;
                                      })
                                    ;
                                  }
								var nimage= imgURL(data.items[i].image, '200X200');
                                    
                                      
                                      cartn +='<div class="cart_item_container"><div class="cart-item__image"><img src='+nimage+' alt="" /></div><div class="cart-item__content"><h5 class="cart-item__title"><a href="'+data.items[i].url+'">'+data.items[i].product_title+'</a></h5><div class="cart-item__bar"><div class="cart-item__entry">'+vrnt+'</div><div class="clear"></div><div class="cart-item__qty"><div class="qty-secondary"><div class="quantityholder numbers-row"><div class="valueButton incs" data-type="minus" field="updates_'+data.items[i].variant_id+'" id="'+data.items[i].variant_id+'" price="">-</div><input  type="number" name="updates[]" id="updates_'+data.items[i].variant_id+'" data-variantid="'+data.items[i].variant_id+'" class="num-box quantity" value='+data.items[i].quantity+' readonly /><div class="valueButton decs" data-type="plus" field="updates_'+data.items[i].variant_id+'" id="'+data.items[i].variant_id+'" price="">+</div></div></div></div></div><div class="cart-item__inner"><span class="cart-item__price">$'+price.toFixed(2)+'</span><span class="cart-item__actions"><a href="#" id='+data.items[i].variant_id+' class="cart-remove removed">Remove</a></span></div></div></div>';
                          
                                  $(".cart__popupsw").html(cartn);
                                $(".totalItems").html('Items('+data.item_count+'):');
                                  $('.cart-sidebar').addClass("navToggle");
                            	$('.checkout-total').css("display", "block");
                                      $('.cartCount').html(data.item_count);
                                      $('.cart_hide').addClass("hide");
                                      $('.cart_hide').css("display", "none");
                                      $('.cart__popupsw').css("display", "block");
                                      
                                       $('.Items-price__bar').css("display", "block");
                                    });
                
                				$('.cart__popup').addClass("popup--box");
                            }else{
                              $('.cart_hide').removeClass("hide");
                              
                              $('.cart__popupsw').css("display", "none");
                               $('.Items-price__bar').css("display", "none");
                               $('.cart_hide').css("display", "block");
                            }
});
          
           
          
          
   },
     error: function (XMLHttpRequest) {
      //console.log();
        
       var jsonRes = $.parseJSON(XMLHttpRequest.responseText);
        $('.err_msg').html(jsonRes.description);
       setTimeout(function(){ $('.err_msg').html(""); }, 8000);
    }
  });
});






// new js-------------------------- nav toggle ------

$(document).ready(function() {
    $(".hamburger").click(function() {
        $(this).toggleClass("is-active");
        $('body').toggleClass("scroll");
        $('.navbar-holder').toggleClass("toggle");

    });

    function close() {
        $('.hamburger').removeClass("is-active");
        $('body').removeClass("scroll");
        $('.navbar-holder').removeClass("toggle");

    }
    $(".close-btn").click(function() {
        close()
    });
    $(".navbar-menuCarot").click(function() {
        $(this).parent().siblings().find(".navbar-menuCarot").removeClass("active");
        $(this).parent().siblings().find(".dropdown-menu").slideUp(500);
        $(this).parent().find(".dropdown-menu").slideToggle(500);
        $(this).toggleClass("active");
    });
    $(".close-btn").click(function() {
        $(this).parent().find(".navbar-menuCarot").removeClass("active");
        $(this).parent().find(".dropdown-menu").slideUp(350);
        $(this).toggleClass("active")

    });

     $('#Quantity-product-template').keypress(function (e) {
          
       var qty= $(this).val();
    if(qty.length > 2 ){return false}

      var charCode = (e.which) ? e.which : event.keyCode    
      if (String.fromCharCode(charCode).match(/[^0-9]/g))    
        return false;                        
    });


     //check update address required
   $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});
 $('.address-btn .add-addr').on('click', function(e) {
  var minLength = 10;
  e.preventDefault();
  var form_id = $(this).closest('form').attr('id');
  required = ["address[first_name]","address[last_name]","address[address1]","address[city]","address[zip]","address[phone]"];
  for (i=0;i<required.length;i++) {
    var input = $('#'+form_id+' input[name="'+required[i]+'"]'); 
     var phone = $('#'+form_id+' input[name="address[phone]"]'); 
    if ((input.val() == "")) {
     input.addClass("needsfilled");
     input.attr("placeholder", "This field is requried.");
    } 
  else if(phone.val().length < minLength){
           phone.addClass("needsfilled");
           phone.attr("placeholder", "Minimum 10 numbers are required.");
            
         }
    
    else {
      input.removeClass("needsfilled");
    }
  }
  if ($(":input").hasClass("needsfilled")) { 
    return false;
  }else {
    $(this).closest('form').submit();
    return true;
  }
});
   
   // remove number from letter orinated fields
   $("input[name='address[first_name]'],input[name='address[last_name]']").bind("keypress", function (e) {
     var key = e.keyCode;
     if (key >= 48 && key <= 57) {
           e.preventDefault();
      }
   });
   
   //remove letter from phone
  $("input[name='address[phone]']").attr({"maxlength" : 15});
   $("input[name='address[phone]']").bind("keypress", function (e) {
             var keyCode = e.which ? e.which : e.keyCode
             
             if ((keyCode == 43)) {
               return true;
             }else if (!(keyCode >= 48 && keyCode <= 57 )){
             return false;
             }
     
   });

    $('input[name="address[zip]"]').attr({"maxlength" : 10});
    $('input[name="address[zip]"]').keypress(function (e) {
      var charCode = (e.which) ? e.which : event.keyCode;
      var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (String.fromCharCode(charCode).match(format))    
        return false;                        
    }); 

  
});
//

  $(document).ready(function () {
  $('#add_contact').on('click', function(e) {
    console.log("contact");
      required = ["ContactForm-name","ContactForm-email","ContactForm-message"];
      for (i=0;i<required.length;i++) {
        var input = $('#ContactForm #'+required[i]); 
        if ((input.val() == "")) {
          input.addClass("needsfilled");
          input.attr("placeholder", "This field is requried.");
          
        }
    
      }
            
      if ($(":input").hasClass("needsfilled")) { 
        return false;
      }else {
        $(this).closest('form').submit();
        return true;
      }

    });
      });

//Banner Slider

       

setTimeout(() => {        
        $(".homeBanner__slider2").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            prevArrow: $(".homeBanner__slider2-arrows .homeBanner__btnLeft"),
            nextArrow: $(".homeBanner__slider2-arrows .homeBanner__btnRight"),
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        });
    }, 1000);



setTimeout(() => {        
        $(".homeBanner__slider3").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            prevArrow: $(".homeBanner__slider3-arrows .homeBanner__btnLeft"),
            nextArrow: $(".homeBanner__slider3-arrows .homeBanner__btnRight"),
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        });
    }, 1000);

setTimeout(() => {        
        $(".homeBanner__sliderfirst").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            prevArrow: $(".homeBanner__sliderfirst-arrows .homeBanner__btnLeft"),
            nextArrow: $(".homeBanner__sliderfirst-arrows .homeBanner__btnRight"),
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        });
    }, 1000);


$(document).ready(function() {
  // Define the HTML content you want to append
  // var htmlToAppend = '<div class="homeBanner__caption">' +
  //                    '<h3>FW24/25 COLLECTION AVAILABLE NOW</h3>' +
  //                    // '<a href="/collections/new-arrivals" class="shopNow-button">Shop Now</a>' +
  //                    '</div>';

   var htmlToAppendslider2 = '<div class="homeBanner__caption">' +
                     '<h3>HEADWEAR DESIGNED BY NATURE</h3>' +
                     // '<a href="/collections/beanies" class="shopNow-button">Shop Now</a>' +
                     '</div>';
  var htmlToAppendslider3 = '<div class="homeBanner__caption">' +
                     '<h3>MTN COLLECTION APPAREL</h3>' +
                     // '<a href="/collections/mtn-collection" class="shopNow-button">Shop Now</a>' +
                     '</div>';

  // Use jQuery to select elements with the class "sliderpopulate1" and append the HTML content
  // $('.sliderpopulate1').append(htmlToAppend);
  //   $('.sliderpopulate2').append(htmlToAppend);
  //   $('.sliderpopulate3').append(htmlToAppend);
  //   $('.sliderpopulate4').append(htmlToAppend);
  
$('.sliderpopulate11').append(htmlToAppendslider2);
    $('.sliderpopulate12').append(htmlToAppendslider2);
    $('.sliderpopulate13').append(htmlToAppendslider2);
    $('.sliderpopulate14').append(htmlToAppendslider2);

  $('.sliderpopulate21').append(htmlToAppendslider3);
    $('.sliderpopulate22').append(htmlToAppendslider3);
    $('.sliderpopulate23').append(htmlToAppendslider3);
    $('.sliderpopulate24').append(htmlToAppendslider3);
});